import { httpClient } from './../httpClient';
import { apiErrorHandler } from './helpers';

/**
 * @param {string} hostId
 * @param {{ year?: number }} [options]
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export const getCurrentNumber = (hostId, { year } = {}) =>
  httpClient
    .get(`/reservation-invoice-running-number/current/${hostId}`, {
      ...(year != null ? { params: { year } } : {})
    })
    .then(response => response)
    .catch(apiErrorHandler);

/**
 * @param {string} hostId
 * @param {{ year?: number }} [options]
 * @returns {Promise<{ hostId?: string, year?: number, invoices?: Array }>}
 */
export const getReservationInvoicesForHost = (hostId, { year } = {}) =>
  httpClient
    .get(`/reservation-invoice-running-number/invoices/${hostId}`, {
      ...(year != null ? { params: { year } } : {})
    })
    .then(response => response.data)
    .catch(apiErrorHandler);
